import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * X Standard icon - official X brand with black background
 * Use this for external links and compositions where you want the official look
 *
 * @example
 * ```tsx
 * <XStandardIcon size="md" />
 * ```
 */
export const XStandardIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="X" {...props}>
      <circle cx="12" cy="12" r="12" fill="#000000" />
      <path
        d="M17.2903 6.56232H15.45L12.4166 10.0372L9.79714 6.56317H6L10.5351 12.5092L6.23571 17.4377H8.07771L11.3949 13.6363L14.2971 17.4377H18L13.2703 11.1686L17.2903 6.56232ZM15.8229 16.3337H14.8029L8.14629 7.60889H9.24L15.8229 16.3337Z"
        fill="#FFFFFF"
      />
    </BaseIcon>
  );
});

XStandardIcon.displayName = "XStandardIcon";
